/**
 * Sanitize HTML email content for safe iframe rendering.
 *
 * Removes any remaining <img> tags with unresolved `cid:` protocol src
 * attributes.  Resolved CID images (whose src has been replaced with an
 * https:// URL during sync) are left intact.
 *
 * Previously this replaced CID images with a visible "[embedded image]"
 * placeholder.  Now the backend resolves CID images to real URLs during
 * email sync, so this is a fallback that silently removes any that were
 * not resolved (e.g., older emails synced before this feature).
 */
export function sanitizeEmailHtml(html: string): string {
  if (!html) return html;

  // Remove <img> tags whose src still starts with "cid:" (unresolved).
  // Resolved images will have https:// URLs and are left untouched.
  return html.replace(
    /<img\b[^>]*\bsrc\s*=\s*["']cid:[^"']*["'][^>]*\/?>/gi,
    '',
  );
}
